import React from "react";

type Props = {
  id: number;
  name: string;
  status: string;
  time: string;
};

const RowAppointmentsListData = ({ id, name, status, time }: Props) => {
  const statusColor = (status: string) => {
    switch (status) {
      case "active":
      case "Active":
      case "Completed":
      case "completed":
        return "#479821";
      case "blocked":
      case "Blocked":
        return "#B0B0C0";
      case "pending":
      case "In progress":
      case "started":
        return "#CF953D";
      case "Upcoming":
      case "created":
        return "#00086D";
      case "Cancelled":
      case "canceled":
        return "#C43535";
      default:
        return "#B0B0C0"; // Default color if status doesn't match any case
    }
  };
  return (
    <>
      <div className="w-full flex items-center text-center gap-2 mr-auto max-w-[50px] text-[#2B3674] text-sm font-medium">
        # {id}
      </div>
      <span className="w-full max-w-[150px] text-[#2B3674] text-sm whitespace-nowrap font-medium text-left ">
        {name}
      </span>
      <span
        style={{ color: statusColor(status) }}
        className="w-full text-[#9999A7] flex items-center font-medium max-w-[150px] text-left text-sm whitespace-nowrap "
      >
        <div
          style={{ background: statusColor(status) }}
          className="w-2 h-2 rounded-full mr-2"
        />
        <span>{status}</span>
      </span>
      <span className="w-full text-[#9999A7] font-medium max-w-[15px] text-left text-sm whitespace-nowrap ">
        {time}
      </span>
    </>
  );
};

export default RowAppointmentsListData;
